module.exports = __webpack_public_path__ + "static/media/admin_smith_image.72859bff.png";